import { IAttachDocumentInvoices } from 'src/types/AttachDocumentInvoices';

export const getOcrQueueSelectionStorageKey = (clientId: number | string): string =>
  `OcrQueue-SelectedAttachId.${clientId}`;

export const readOcrQueueAttachIdFromSession = (clientId: number | string): number | null => {
  if (typeof window === 'undefined' || !clientId) {
    return null;
  }

  try {
    const raw = sessionStorage.getItem(getOcrQueueSelectionStorageKey(clientId));
    if (!raw) {
      return null;
    }

    const parsed = Number(JSON.parse(raw));
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  } catch {
    return null;
  }
};

export const applyOcrQueuePreviewSelection = (
  items: IAttachDocumentInvoices[],
  attachId: number | null
): IAttachDocumentInvoices[] => {
  if (items.length === 0) {
    return items;
  }

  let selectedIndex = 0;
  if (attachId) {
    const storedIndex = items.findIndex((item) => item.attachId === attachId);
    selectedIndex = storedIndex >= 0 ? storedIndex : 0;
  }

  return items.map((item, index) => ({
    ...item,
    preview: index === selectedIndex,
  }));
};
